import { createContext, useContext } from "react";

export const CanvasBindingsContext: React.Context<object> = createContext(null);
export const useCanvasBindings: () => object = () => useContext(CanvasBindingsContext);